import { useMutation } from '@apollo/client';
import { Mutation, MutationOnboardingChooseProviderArgs, Provider } from 'graphql/generated/graphqlTypes';
import { CHOOSE_PROVIDER } from 'graphql/mutations';
import { GET_CURRENT_TENANT } from 'graphql/queries';
import { BaseHookProps } from 'hooks/shared/types';
import { useEffect } from 'react';

const useChooseProvider = ({ handleFetchError }: BaseHookProps) => {
  const [chooseProviderMutation, { loading, error }] = useMutation<
    Pick<Mutation, 'onboardingChooseProvider'>,
    MutationOnboardingChooseProviderArgs
  >(CHOOSE_PROVIDER, {
    refetchQueries: [{ query: GET_CURRENT_TENANT }],
    awaitRefetchQueries: true
  });

  useEffect(() => {
    if (error) {
      handleFetchError('Error while choosing provider');
      console.error(error);
    }
  }, [error]);

  const chooseProvider = async (provider: Provider) => {
    await chooseProviderMutation({
      variables: {
        provider
      }
    });
  };

  return {
    loading,
    chooseProvider
  };
};

export default useChooseProvider;
